/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostRecord {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostRecord.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostRecord>): AIUnitEconomicsCostRecord {
        let obj = Object.assign(new AIUnitEconomicsCostRecord(), model);
        AIUnitEconomicsCostRecord.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostRecord>): AIUnitEconomicsCostRecord {
        if (!model) return null;
        return AIUnitEconomicsCostRecord.newInstance(<AIUnitEconomicsCostRecord> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostRecord) {
        if (!obj) return;

        models.AIUnitEconomicsCostRecord.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostRecord): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostRecord.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.input_cost === undefined) {
            this.input_cost = 0;
        }
        if (this.output_cost === undefined) {
            this.output_cost = 0;
        }
        if (this.input_tokens === undefined) {
            this.input_tokens = 0;
        }
        if (this.output_tokens === undefined) {
            this.output_tokens = 0;
        }
        if (this.total_tokens === undefined) {
            this.total_tokens = 0;
        }
        if (this.record_count === undefined) {
            this.record_count = 0;
        }
        if (typeof this.usage_date === "string") {
            this.usage_date = new Date(<string><any>this.usage_date);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Cost bucket ID
     */
    id: string;

    /**
     * Baseline this cost was consolidated against
     */
    baseline_id: string;

    /**
     * Source the cost came from: 'ai_agents' for agent traces, 'ai_cost' for prompt analytics
     */
    record_type: models.AIUnitEconomicsBaselineType;

    /**
     * Baseline field the cost was matched on, carried so the bucket is self-describing
     */
    primary_key: string;

    /**
     * Value of the primary key this cost belongs to
     */
    primary_key_value: string;

    /**
     * Service account the cost was incurred under
     */
    service_account_id: string;

    /**
     * Model the cost was incurred on, or 'unknown' when it could not be resolved
     */
    model_id: string;

    /**
     * Display name for the model
     */
    model_name: string;

    /**
     * Agent display name; populated for the ai_agents type only
     */
    agent_name: string;

    /**
     * User the spans were attributed to, resolved from the span's user attributes; empty when the source carries no user
     */
    user: string;

    /**
     * Region the cost was priced in
     */
    region: string;

    /**
     * Baseline tags copied onto the bucket for roll-up
     */
    tags: Array<models.KeyValuePair>;

    /**
     * UTC day this cost was incurred
     */
    usage_date: Date;

    /**
     * Input-token cost
     */
    input_cost: number;

    /**
     * Output-token cost
     */
    output_cost: number;

    /**
     * Input token count
     */
    input_tokens: number;

    /**
     * Output token count
     */
    output_tokens: number;

    /**
     * Total token count
     */
    total_tokens: number;

    /**
     * Spans (ai_agents) or invocations (ai_cost) in this bucket; the denominator for cost per execution
     */
    record_count: number;

}
